import axios from "axios";

// Kreiramo Axios instancu sa osnovnim podešavanjima
const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { "Content-Type": "application/json" },
});

// ✅ Interceptor za automatsko dodavanje tokena u zahteve
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // Uzimamo token iz localStorage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // Dodajemo token u svaki zahtev
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ✅ Interceptor za globalno rukovanje greškama (opciono)
API.interceptors.response.use(
  (response) => response, // Ako je sve OK, samo vrati response
  (error) => {
    if (error.response && error.response.status === 401) {
      // Ako backend vrati 401 (Unauthorized), brišemo token i izlogujemo korisnika
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login"; // Preusmeravamo korisnika na login
    }
    return Promise.reject(error);
  }
);

export default API;
